enum ProductOrderDeliveryPersonStatus {
    ASSIGNED = "ASSIGNED",
    PENDING="PENDING",
    RECEIVED= "RECEIVED",
    DELIVERED="DELIVERED",
}

export default ProductOrderDeliveryPersonStatus;
